module.exports = __webpack_public_path__ + "img/IMG_9543_L_BlackMatted.badd1d3e.jpg";